export default "__VITE_ASSET__BKgtcZeq__"